// The Oktober mark as the first frame of the splash: the orange "OKT" short
// mark, centred on the light page. index.html, OktoberLoadingScreen and
// SplashOverlay all draw this same frame, so a first load shows Oktober from
// the first paint and the splash starts from what is already on screen.

// logo-ok.svg (the "OKT" short mark, 570.2×323.8) is the exact left portion of
// logo-oktober.svg (1356×324), so revealing the full wordmark is a pure width
// expansion — no cross-fade needed.
export const FULL_AR = 1356 / 324;
export const OKT_FRACTION = 570.2 / 1356;

// Responsive mark height, resolvable in CSS so the first frame is correct
// before any script runs (index.html repeats this value).
export const MARK_HEIGHT = "clamp(120px, 15vw, 230px)";

/** Where the mark's centre sits: horizontally centred, 42% down the viewport. */
export const MARK_TOP = "42%";

// Whether the mark is on screen right now (the index.html loader, then
// OktoberLoadingScreen), so the splash skips its entrance instead of making
// the mark vanish and slide in again. Pages that replace it (the account
// pages) clear it.
let onScreen = typeof document !== "undefined" && document.getElementById("initial-loader") !== null;

export const markOnScreen = () => onScreen;

export function setMarkOnScreen(value: boolean): void {
  onScreen = value;
}
